<template>
  <div id="customers">
    <ActiveCompanyTable :v-table-name="TABLE_NAME_CUSTOMERS_ACTIVE" :refresh="refreshTable" />
    <EditCompanyGeneralInfoModal :id="EDIT_COMPANY_GENERAL_INFO_MODAL" @update="doRefresh" />
    <EditCompanyAddressModal :id="EDIT_COMPANY_ADDRESS_MODAL" @update="doRefresh" />
    <EditCompanyTaxNumbersModal :id="EDIT_COMPANY_TAX_NUMBERS_MODAL" @update="doRefresh" />

    <SenderAddressesModal :id="SENDER_ADDRESSES" />
    <SenderAddressActionModal :id="SENDER_ADDRESS_ACTION" />

    <UsersModal :id="USERS" />
    <UserCreateEditModal :id="USERS_CREATE_EDIT" />

    <IntegrationsActionModal :id="INTEGRATIONS" />
    <IntegrationsDetailsModal :id="INTEGRATION_DETAILS" />
    <IntegrationsOrdersModal :id="INTEGRATION_ORDERS" />
    <IntegrationsMagentoKeysModal :id="MAGENTO_KEYS" />
    <IntegrationsWoocommerceKeysModal :id="WOO_COMMERCE_KEYS" />
    <IntegrationsShopifySettingsModal :id="SHOPIFY_WEBHOOK_SETTINGS" />
    <IntegrationsOngoingSettingsModal :id="ONGOING_WEBHOOK_SETTINGS" />
    <IntegrationsViskanSettingsModal :id="VISKAN_SETTINGS" />
  </div>
</template>

<script lang="ts">
import { defineAsyncComponent, defineComponent, onMounted, ref } from 'vue'
import {
  EDIT_COMPANY_ADDRESS_MODAL,
  EDIT_COMPANY_GENERAL_INFO_MODAL,
  EDIT_COMPANY_TAX_NUMBERS_MODAL,
  INTEGRATION_DETAILS,
  INTEGRATION_ORDERS,
  INTEGRATIONS,
  ONGOING_WEBHOOK_SETTINGS,
  SENDER_ADDRESS_ACTION,
  SENDER_ADDRESSES,
  SHOPIFY_WEBHOOK_SETTINGS,
  WOO_COMMERCE_KEYS,
  VISKAN_SETTINGS,
  USERS_CREATE_EDIT,
  USERS,
  MAGENTO_KEYS,
} from '@/const/ModalTypes'
import { TABLE_NAME_CUSTOMERS_ACTIVE } from '@/const/TableNames'
import { registerModals } from '@/services/Modal'
import UsersModal from '@/views/Modals/Customer/UsersListModal.vue'
import UserCreateEditModal from '@/views/Modals/Customer/UserCreateEditModal.vue'
import SenderAddressesModal from '@/views/Modals/SenderAddress/SenderAddressesModal.vue'
import EditCompanyAddressModal from '@/views/Modals/Customer/EditCompanyAddressModal.vue'
import IntegrationsActionModal from '@/views/Modals/Integrations/IntegrationsActionModal.vue'
import IntegrationsOrdersModal from '@/views/Modals/Integrations/IntegrationsOrdersModal.vue'
import IntegrationsDetailsModal from '@/views/Modals/Integrations/IntegrationsDetailsModal.vue'
import SenderAddressActionModal from '@/views/Modals/SenderAddress/SenderAddressActionModal.vue'
import EditCompanyTaxNumbersModal from '@/views/Modals/Customer/EditCompanyTaxNumbersModal.vue'
import EditCompanyGeneralInfoModal from '@/views/Modals/Customer/EditCompanyGeneralInfoModal.vue'
import IntegrationsMagentoKeysModal from '@/views/Modals/Integrations/IntegrationsMagentoKeysModal.vue'
import IntegrationsViskanSettingsModal from '@/views/Modals/Integrations/IntegrationsViskanSettingsModal.vue'
import IntegrationsOngoingSettingsModal from '@/views/Modals/Integrations/IntegrationsOngoingSettingsModal.vue'
import IntegrationsShopifySettingsModal from '@/views/Modals/Integrations/IntegrationsShopifySettingsModal.vue'
import IntegrationsWoocommerceKeysModal from '@/views/Modals/Integrations/IntegrationsWoocommerceKeysModal.vue'

export default defineComponent({
  name: 'CustomersListPage',
  components: {
    UsersModal,
    UserCreateEditModal,
    SenderAddressActionModal,
    SenderAddressesModal,
    EditCompanyGeneralInfoModal,
    EditCompanyAddressModal,
    EditCompanyTaxNumbersModal,
    IntegrationsActionModal,
    IntegrationsDetailsModal,
    IntegrationsOrdersModal,
    IntegrationsMagentoKeysModal,
    IntegrationsWoocommerceKeysModal,
    IntegrationsShopifySettingsModal,
    IntegrationsOngoingSettingsModal,
    IntegrationsViskanSettingsModal,
    ActiveCompanyTable: defineAsyncComponent(() => import('@/views/Components/Customer/ActiveCompaniesTable.vue')),
  },
  setup(): Record<string, any> {
    const refreshTable = ref('')
    const doRefresh = () => {
      refreshTable.value = Math.random().toString()
    }
    onMounted(() => {
      registerModals(EDIT_COMPANY_GENERAL_INFO_MODAL)
      registerModals(EDIT_COMPANY_ADDRESS_MODAL)
      registerModals(EDIT_COMPANY_TAX_NUMBERS_MODAL)

      registerModals(SENDER_ADDRESSES)
      registerModals(SENDER_ADDRESS_ACTION)

      registerModals(USERS)
      registerModals(USERS_CREATE_EDIT)

      registerModals(INTEGRATIONS)
      registerModals(INTEGRATION_DETAILS)
      registerModals(WOO_COMMERCE_KEYS)
      registerModals(MAGENTO_KEYS)
      registerModals(SHOPIFY_WEBHOOK_SETTINGS)
      registerModals(ONGOING_WEBHOOK_SETTINGS)
      registerModals(VISKAN_SETTINGS)
      registerModals(INTEGRATION_ORDERS)
    })

    return {
      doRefresh,
      refreshTable,
      EDIT_COMPANY_GENERAL_INFO_MODAL,
      EDIT_COMPANY_TAX_NUMBERS_MODAL,
      TABLE_NAME_CUSTOMERS_ACTIVE,
      EDIT_COMPANY_ADDRESS_MODAL,
      ONGOING_WEBHOOK_SETTINGS,
      SHOPIFY_WEBHOOK_SETTINGS,
      SENDER_ADDRESS_ACTION,
      INTEGRATION_DETAILS,
      INTEGRATION_ORDERS,
      USERS_CREATE_EDIT,
      WOO_COMMERCE_KEYS,
      SENDER_ADDRESSES,
      VISKAN_SETTINGS,
      MAGENTO_KEYS,
      INTEGRATIONS,
      USERS,
    }
  },
})
</script>
